import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-telphone",
  "use": "icon-telphone-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-telphone\"><defs><style type=\"text/css\"></style></defs><path d=\"M699.934 409.78c-1.084-1.746-13.07-20.9-16.444-26.503-6.265-10.36-10.963-18.914-14.818-27.467-27.347-60.11500001-8.011-113.12200001 73.909-183.236 50.718-43.37 95.714-56.2 135.77-39.454 29.937 12.469 50.598 36.503 76.13699999 79.27 1.627 2.77 15.963 27.407 19.87800002 33.731 61.44 99.57-79.21 327.8-319.54800001 491.942C413.877 902.626 156.973 945.213 94.63000001 844.318l-8.43300001-13.312L76.8 816.55c-33.009-51.02000001-46.2-83.667-39.635-122.398 6.626-38.672 35.238-71.56 87.341-99.389 110.23-58.66900001 162.515-45.718 210.04 29.757 3.494 5.42 15.12 24.696 16.264 26.503 11.445 18.492 88.125-12.83 194.741-85.655C653.37199999 491.64 712.343 430.02 699.934 409.84100001z\" fill=\"#ff9700\" p-id=\"889\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/telphone.svg
// module id = u3wy
// module chunks = 81